export default __webpack_public_path__ + "navigation-examples-basic-960-75a60ac15c2f19e06a9c48405761e159.png";